import type { SimNextStep } from '@cruz/shared';
import { card, Meter } from './ui.tsx';

/**
 * «Tu próximo paso»: the next post and what it asks for, so every choice has a reason.
 * The engine decides when an opportunity comes; this only shows how far you are.
 */

const pct = (have: number, need: number) => (need <= 0 ? 100 : Math.round((have / need) * 100));

function Requirement({
  label,
  have,
  need,
  unit = '',
}: {
  label: string;
  have: number;
  need: number;
  unit?: string;
}) {
  const done = have >= need;
  return (
    <li>
      <p className="mb-1 flex justify-between gap-3 text-[0.95rem]">
        <span>{label}</span>
        <span className={`tabular font-semibold ${done ? 'text-gold-700 dark:text-gold-300' : ''}`}>
          {done && <span aria-hidden>✓ </span>}
          {have} de {need}
          {unit}
          {done && <span className="sr-only"> (cumplido)</span>}
        </span>
      </p>
      <Meter value={pct(have, need)} label={label} />
    </li>
  );
}

export function NextStepCard({ step }: { step: SimNextStep }) {
  return (
    <section aria-labelledby="next-step" className={`${card} px-5 py-4`}>
      <p className="text-xs font-semibold tracking-[0.16em] text-gold-700 uppercase dark:text-gold-300">
        Tu próximo paso
      </p>
      <h2 id="next-step" className="mt-1 font-serif text-2xl leading-tight font-semibold">
        {step.rank_label}
      </h2>
      <ul className="mt-3 space-y-3">
        <Requirement
          label="Antigüedad"
          have={step.years.have}
          need={step.years.need}
          unit=" años"
        />
        {step.stats.map((s) => (
          <Requirement key={s.key} label={s.label} have={s.have} need={s.need} />
        ))}
      </ul>
      <p className="mt-3 text-[0.95rem] text-ink-soft dark:text-cream/75">
        {step.by_election
          ? step.ready
            ? 'Ya puedes presentarte a hermano mayor: las elecciones llegan cada pocos años, y los votos dependen de tu prestigio y de tu gente.'
            : 'El hermano mayor se elige en cabildo. Cuando lo cumplas todo, podrás presentarte en las siguientes elecciones.'
          : step.ready
            ? 'Lo cumples todo: el cabildo puede ofrecerte el cargo cualquier día. No es seguro: también cuenta cómo te lleves con el hermano mayor.'
            : 'Cuando lo cumplas todo, el cabildo puede ofrecerte el cargo.'}
      </p>
    </section>
  );
}
